import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  error: null,
  processInfo: null,
  summary: null,
  transactions: [],
  pagination: {
    page: 1,
    limit: 10,
    total: 0,
    total_pages: 1,
  },
  updatingStatus: false,
  payslip: null,
  payslipLoading: false,
};

const processPayrollSlice = createSlice({
  name: "processPayroll",
  initialState,
  reducers: {
    // Get Payroll Report
    getPayrollReportStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    getPayrollReportSuccess: (state, action) => {
      state.loading = false;
      state.transactions = action.payload.payrolls || [];
      state.pagination = action.payload.pagination || initialState.pagination;
      // Calculate summary from transactions
      if (state.transactions.length > 0) {
        state.summary = {
          total_employees: state.transactions.length,
          total_net_salary: state.transactions.reduce(
            (sum, t) =>
              sum + parseFloat(t.net_salary || t.configured_net_salary || 0),
            0,
          ),
          total_deductions: state.transactions.reduce(
            (sum, t) =>
              sum +
              parseFloat(
                t.total_deduction || t.configured_total_deduction || 0,
              ),
            0,
          ),
        };
      } else {
        state.summary = null;
      }
      state.error = null;
    },
    getPayrollReportFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // Process Monthly Payroll
    processMonthlyPayrollStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    processMonthlyPayrollSuccess: (state) => {
      state.loading = false;
      state.error = null;
    },
    processMonthlyPayrollFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // Update Transaction Status
    updateTransactionStatusStart: (state) => {
      state.updatingStatus = true;
      state.error = null;
    },
    updateTransactionStatusSuccess: (state, action) => {
      state.updatingStatus = false;
      const index = state.transactions.findIndex(
        (transaction) => transaction.id === action.payload.id,
      );
      if (index !== -1) {
        state.transactions[index] = {
          ...state.transactions[index],
          ...action.payload,
        };
      }
      state.error = null;
    },
    updateTransactionStatusFailure: (state, action) => {
      state.updatingStatus = false;
      state.error = action.payload;
    },

    // Get Payslip
    getPayslipStart: (state) => {
      state.payslipLoading = true;
      state.error = null;
    },
    getPayslipSuccess: (state, action) => {
      state.payslipLoading = false;
      state.payslip = action.payload;
      state.error = null;
    },
    getPayslipFailure: (state, action) => {
      state.payslipLoading = false;
      state.error = action.payload;
    },

    // Clear Error
    clearError: (state) => {
      state.error = null;
    },
  },
});

export const {
  getPayrollReportStart,
  getPayrollReportSuccess,
  getPayrollReportFailure,
  processMonthlyPayrollStart,
  processMonthlyPayrollSuccess,
  processMonthlyPayrollFailure,
  updateTransactionStatusStart,
  updateTransactionStatusSuccess,
  updateTransactionStatusFailure,
  getPayslipStart,
  getPayslipSuccess,
  getPayslipFailure,
  clearError,
} = processPayrollSlice.actions;

export default processPayrollSlice.reducer;
